import FormData from 'form-data';
import { ImageMapper } from './ImageMapper';

export class ImageApi {
  constructor(api) {
    this.api = api;
  }

  async post(formId, image) {
    try {
      const formData = new FormData();
      formData.append('file', ImageMapper.mapArrayBufferToBlob(image), 'image.jpg');
      const { data } = await this.api('updateImage', { formId }, null, formData, null, 'image');
      return data;
    } catch (e) {
      if (!e.toString().includes('AbortError')) {
        throw new Error('Error upload image');
      }
    }
    return null;
  }

  async get(imageId) {
    const { data } = await this.api('getImage', { imageId });
    const res = await ImageMapper.mapBlobToB64(await ImageMapper.mapStreamToBlob(data));
    return res;
  }
}
